<script setup lang="ts">
defineProps<{
  title: string;
  items: { title: string; description: string }[];
}>();
</script>

<template>
  <section class="mt-12">
    <div class="mb-6 max-w-2xl">
      <p class="text-sm font-semibold uppercase tracking-[0.16em] text-brand-600">
        A practical sequence
      </p>
      <h2 class="mt-2 text-3xl font-bold text-brand-900">
        {{ title }}
      </h2>
    </div>
    <ol class="grid gap-4 md:grid-cols-3">
      <li
        v-for="(item, index) in items"
        :key="item.title"
        class="rounded-2xl border border-slate-200 bg-white p-6 shadow-[var(--shadow-card)]"
      >
        <span class="flex size-10 items-center justify-center rounded-full bg-brand-100 font-bold text-brand-800">
          {{ index + 1 }}
        </span>
        <h3 class="mt-5 text-lg font-semibold text-slate-900">
          {{ item.title }}
        </h3>
        <p class="mt-2 text-sm leading-6 text-slate-600">
          {{ item.description }}
        </p>
      </li>
    </ol>
  </section>
</template>
